import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMultiMedia: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMultiMedia"><Path d="M6.25 7.5C6.94036 7.5 7.5 6.94036 7.5 6.25C7.5 5.55964 6.94036 5 6.25 5C5.55964 5 5 5.55964 5 6.25C5 6.94036 5.55964 7.5 6.25 7.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M16 2H2V16H8V22H22V8H16V2ZM14 8V4H4V10.1312L6.00001 8.79785L8 10.1312V8H14ZM13 12L18 15L13 18V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMultiMedia;
